// Torch and Tinder · lightweight scroll reveal
(function() {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = () => document.querySelectorAll('.tt-reveal:not(.is-visible)');

  const reveal = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  };

  const init = () => {
    if (!('IntersectionObserver' in window)) {
      targets().forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(reveal, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    targets().forEach(el => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan after Shopify section reloads in theme editor
  document.addEventListener('shopify:section:load', init);
})();
